/**
 * @returns {null}
 * @constructor
 */
var StickyTable = function () {
  var self = this
  this.WIDTH_RUN = 768
  this.previousWidth = Number.MAX_VALUE
  this.tables = document.getElementsByClassName('csas-sticked-table')
  this.tr = []

  if (!this.tables.length) {
    return null
  }

  console.info('Run StickyTable ...')

  this.run = function () {
    if (self.WIDTH_RUN < window.outerWidth) {
      if (self.previousWidth !== Number.MAX_VALUE) {
        self.reset()
      }
      return self
    } else {
      if (self.previousWidth < window.outerWidth) {
        self.reset()
      }
      self.calculate()
      self.previousWidth = window.outerWidth
    }
  }

  this.calculate = function () {
    if (!this.tr.length) {
      this.getAllTr()
    }
    if (this.tr.length) {
      for (var i = 0; i < this.tr.length; i++) {
        this.setHeight(this.tr[i])
      }
    }
  }

  this.reset = function () {
    if (!this.tr.length) {
      this.getAllTr()
    }
    if (this.tr.length) {
      for (var i = 0; i < this.tr.length; i++) {
        var td = this.tr[i].getElementsByTagName('td')
        if (!td.length) {
          td = this.tr[i].getElementsByTagName('th')
        }
        for (var x = 0; x < td.length; x++) {
          td[x].style.height = null
        }
      }
    }
  }

  /**
   * @param tr HTMLTableRowElement
   */
  this.setHeight = function (tr) {
    var td = tr.getElementsByTagName('td')
    if (!td.length) {
      td = tr.getElementsByTagName('th')
    }
    var maxHeight = 0
    for (var i = 0; i < td.length; i++) {
      if (maxHeight < td[i].offsetHeight) {
        maxHeight = td[i].offsetHeight
      }
    }
    for (var j = 0; j < td.length; j++) {
      td[j].style.height = maxHeight + 'px'
    }
  }

  this.getAllTr = function () {
    for (var i = 0; i < this.tables.length; i++) {
      var table = this.tables[i]
      var trs = table.querySelectorAll('tr')
      if (trs.length) {
        for (var z = 0; z < trs.length; z++) {
          this.tr.push(trs[z])
        }
      }
    }
  }

  this.run()
  window.addEventListener('resize', this.run)
}

module.exports = {
  StickyTable: StickyTable
}
